import styled from "styled-components";

const Inner = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

const Outer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;	
`;

const VerticalCenter: React.SFC<any> = ({ children, ...restProps }) => {
	return (
		<Outer {...restProps}>
			<Inner>
				{children}
			</Inner>
		</Outer>
	);
};

export default VerticalCenter;



// WEBPACK FOOTER //
// ./src/common/fragments/VerticalCenter.tsx